import useTranslation from 'next-translate/useTranslation'

import Arrow from '@/atoms/Arrow/Arrow'

function ProprietaryProductsSection() {
  const { t } = useTranslation('forCreators')
  return (
    <div className="py-8 text-center border-2 border-l-0 border-r-0 md:py-16 xl:py-24 md:px-16 border-gray-5">
      <div className="flex flex-col items-center justify-center space-y-8">
        <h2 className="text-2xl font-semibold sm:text-3xl lg:text-6xl">
          {t('oryginal_products')}
        </h2>
        <p className="sm:text-xl lg:text-2xl">{t('oryginal_products_desc')}</p>
        <Arrow
          variant="rounded"
          className="w-12 h-12 mx-auto text-black transform -rotate-270 md:h-16 md:w-16"
          direction="down"
        />
      </div>
    </div>
  )
}

export default ProprietaryProductsSection
